<template>
  <v-flex class="commission-table-layout">
    <table class="commission-table" border="1">
      <thead>
      <tr class="commission-table-header">
        <th colspan="2">
          대출과목(종류)
        </th>
        <th>중개업소(유)</th>
        <th>중개업소(무)</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td rowspan="2">주택담보</td>
        <td>일반(아파트)</td>
          <td :class="{'modify': isModify}">
            <span v-if="!isModify">{{ feeData.houseGenY }}%</span>
            <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.houseGenY" outlined hide-details dense maxLength="7" />
          </td>
          <td :class="{'modify': isModify}">
            <span v-if="!isModify">{{ feeData.houseGenN }}%</span>
            <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.houseGenN" outlined hide-details dense maxLength="7" />
          </td>
      </tr>
      <tr>
        <td>연립/빌라 등</td>
        <td :class="{'modify': isModify}">
          <span v-if="!isModify">{{ feeData.houseVilY }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.houseVilY" outlined hide-details dense maxLength="7" />
        </td>
        <td :class="{'modify': isModify}">
          <span v-if="!isModify">{{ feeData.houseVilN }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.houseVilN" outlined hide-details dense maxLength="7" />
        </td>
      </tr>

      <tr>
        <td rowspan="2">유동화적격</td>
        <td>장기고정금리</td>
        <td :class="{'modify': isModify}">
          <span v-if="!isModify">{{ feeData.securitizationLfixedY }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.securitizationLfixedY" outlined hide-details dense maxLength="7" />
        </td>
        <td :class="{'modify': isModify}">
          <span v-if="!isModify">{{ feeData.securitizationLfixedN }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.securitizationLfixedN" outlined hide-details dense maxLength="7" />
        </td>
      </tr>
      <tr>
        <td>금리고정형</td>
        <td :class="{'modify': isModify}">
          <span v-if="!isModify">{{ feeData.securitizationFixedY }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.securitizationFixedY" outlined hide-details dense maxLength="7" />
        </td>
        <td :class="{'modify': isModify}">
          <span v-if="!isModify">{{ feeData.securitizationFixedN }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.securitizationFixedN" outlined hide-details dense maxLength="7" />
        </td>
      </tr>

      <tr>
        <td rowspan="1">부동산담보</td>
        <td>주거용오피스텔</td>
        <td :class="{'modify': isModify}">
          <span v-if="!isModify">{{ feeData.realestateResiofficetelY }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.realestateResiofficetelY" outlined hide-details dense maxLength="7" />
        </td>
        <td :class="{'modify': isModify}">
          <span v-if="!isModify">{{ feeData.realestateResiofficetelN }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.realestateResiofficetelN" outlined hide-details dense maxLength="7" />
        </td>
      </tr>

      <tr>
        <td colspan="2">전세자금</td>
        <td :class="{'modify': isModify}">
          <span v-if="!isModify">{{ feeData.jeonseFundY }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.jeonseFundY" outlined hide-details dense maxLength="7" />
        </td>
        <td :class="{'modify': isModify}">
          <span v-if="!isModify">{{ feeData.jeonseFundN }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.jeonseFundN" outlined hide-details dense maxLength="7" />
        </td>
      </tr>

      <tr>
        <td rowspan="3">자동차금융</td>
        <td>신차/택시</td>
        <td :class="{'modify': isModify}">
          <span v-if="!isModify">{{ feeData.carfinanceNewtaxiY }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.carfinanceNewtaxiY" outlined hide-details dense maxLength="7" />
        </td>
        <td :class="{'modify': isModify}">
          <span v-if="!isModify">{{ feeData.carfinanceNewtaxiN }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.carfinanceNewtaxiN" outlined hide-details dense maxLength="7" />
        </td>
      </tr>
      <tr>
        <td>화물차</td>
        <td :class="{'modify': isModify}">
          <span v-if="!isModify">{{ feeData.carfinanceTruckY }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.carfinanceTruckY" outlined hide-details dense maxLength="7" />
        </td>
        <td :class="{'modify': isModify}">
          <span v-if="!isModify">{{ feeData.carfinanceTruckN}}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.carfinanceTruckN" outlined hide-details dense maxLength="7" />
        </td>
      </tr>
      <tr>
        <td>중고차</td>
        <td :class="{'modify': isModify}">
          <span v-if="!isModify">{{ feeData.carfinanceUsedY }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.carfinanceUsedY" outlined hide-details dense maxLength="7" />
        </td>
        <td :class="{'modify': isModify}">
          <span v-if="!isModify">{{ feeData.carfinanceUsedN }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.carfinanceUsedN" outlined hide-details dense maxLength="7" />
        </td>
      </tr>

      <tr>
        <td rowspan="5">집단대출</td>
        <td>집단 이주 잔금</td>
        <td :class="{'modify': isModify}" colspan="2">
          <span v-if="!isModify">{{ feeData.grploanMovebal }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.grploanMovebal" outlined hide-details dense maxLength="7" />
        </td>
      </tr>
      <tr>
        <td>집단 전세 대출</td>
        <td :class="{'modify': isModify}" colspan="2">
          <span v-if="!isModify">{{ feeData.grploanJeonse }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.grploanJeonse" outlined hide-details dense maxLength="7" />
        </td>
      </tr>
      <tr>
        <td>이주비</td>
        <td :class="{'modify': isModify}" colspan="2">
          <span v-if="!isModify">건당(대출금액 불금) {{ inputComma(feeData.grploanMovecost) }}원</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.grploanMovecost" outlined hide-details dense />
        </td>
      </tr>
      <tr>
        <td>중도금(대면)</td>
        <td :class="{'modify': isModify}" colspan="2">
          <span v-if="!isModify">건당(대출금액 불금) {{ inputComma(feeData.grploanInterimface) }}원</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.grploanInterimface" outlined hide-details dense />
        </td>
      </tr>
      <tr>
        <td>중도금(비대면)</td>
        <td :class="{'modify': isModify}" colspan="2">
          <span v-if="!isModify">건당(대출금액 불금) {{ inputComma(feeData.grploanInterimremote) }}원</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.grploanInterimremote" outlined hide-details dense />
        </td>
      </tr>

      <tr>
        <td rowspan="2">신용대출</td>
        <td>새희망홀씨</td>
        <td :class="{'modify': isModify}" colspan="2">
          <span v-if="!isModify">{{ feeData.crdtloanNewholssi }}%</span>
          <v-text-field class="modify-text-field" v-if="isModify" v-model="modifyData.crdtloanNewholssi" outlined hide-details dense maxLength="7" />
        </td>
      </tr>
      </tbody>
    </table>
  </v-flex>
</template>

<script>
import _ from "lodash";
import TableMixin from "@/mixin/TableMixin";

export default {
  name: "CommissionConditionTable",
  props: ["feeData", "isModify"],
  mixins: [TableMixin],
  data() {
    return {
      modifyData: {}
    }
  },
  watch: {
    isModify(value) {
      if (value) {
        if (!_.isEmpty(this.feeData)) {
          this.modifyData = _.cloneDeep(this.feeData);
        }
        this.$emit("modifyData", this.modifyData);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.commission-table-layout {
  border: 1px solid #222;
  .commission-table {
    border-collapse: collapse;
    width: 100%;
    text-align: center;
    font-size: min(3vw, 15px);
    .commission-table-header {
      background-color: #e0e0e0;
      border-left: 1px solid #222;
    }
    tr {
      th,
      td {
        border-left: 1px solid #222;
        height: 40px;
        .v-text-field input {
          text-align: center;
        }
      }
      td.modify {
        .modify-text-field {
          margin: 0 auto;
          padding: 5px 0;
          width: 150px;
        }
        .modify-text-field ::v-deep input {
          text-align: center;
        }
      }
    }
  }
}
</style>